export const WHATSAPP_NUMBER = "917002862280";
export const OFFICIAL_PHONE = "7002862280";
export const OFFICIAL_DOMAIN = "akkshaynarula.com";
export const HERO_PHOTO = "https://customer-assets.emergentagent.com/job_celestial-guide-78/artifacts/pnwujiwp_file_00000000315871fab2374d57369b0312.png";

const BASE_MSG = "Hello Akkshay ji, I want to book a consultation.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(BASE_MSG)}`;

export const UPI_ID = "7002862280";
export const BANK_ACCOUNT = "278201503229";
export const BANK_NAME = "AKSHAY NARULA";
export const BANK_IFSC = "ICIC0003863";
export const BANK_BRANCH = "ICICI Bank";

export const ASTROLOGY_SERVICES = [
  { id: "kundli-online", name: "Kundli Analysis (Online)", price: 3100, mode: "Telephonic / Chat", location: "Online", description: "In-depth telephonic or chat-based analysis of your birth chart with personalised life insights." },
  { id: "kundli-inperson", name: "Kundli Consultation (In-Person)", price: 5100, mode: "In-Person", location: "Guwahati & Bangalore", description: "Face-to-face kundli consultation at Guwahati or Bangalore." },
  { id: "numerology-online", name: "Numerology Reading (Online)", price: 3100, mode: "Online", location: "Online", description: "Core number analysis, strengths, challenges, and life themes — delivered online." },
  { id: "numerology-inperson", name: "Numerology Consultation (In-Person)", price: 5100, mode: "In-Person", location: "Guwahati & Bangalore", description: "Detailed numerology session in person at Guwahati or Bangalore." },
  { id: "marriage-online", name: "Marriage / Compatibility Analysis (Online)", price: 5100, mode: "Online · 2 People", location: "Online", description: "Comprehensive compatibility analysis for couples — charts, doshas, and life harmony." },
  { id: "marriage-inperson", name: "Marriage / Compatibility Analysis (In-Person)", price: 7100, mode: "In-Person · 2 People", location: "Guwahati & Bangalore", description: "In-depth face-to-face compatibility analysis for couples at Guwahati or Bangalore." },
];

export const ASTROCARTOGRAPHY_SERVICES = [
  { id: "astrocartography", name: "Astrocartography Consultation", price: 5100, mode: "Online", location: "Online", description: "Location-based planetary analysis for career growth, relocation, best city/country selection, and business expansion zones." },
];

export const VASTU_RESIDENTIAL = [
  { id: "vastu-apt", name: "Apartment (In-Person)", price: 11000, mode: "In-Person", location: "Guwahati & Bangalore", description: "On-site Vastu analysis for residential apartments." },
  { id: "vastu-bungalow", name: "Bungalow / Independent House (In-Person)", price: 21000, mode: "In-Person", location: "Guwahati & Bangalore", description: "Comprehensive Vastu analysis for bungalows and independent houses." },
  { id: "vastu-digital-res", name: "Digital Vastu (Residence)", price: 5100, mode: "Online", location: "Online", description: "Online consultation based on layout, photos, and video of your residence." },
];

export const VASTU_COMMERCIAL = [
  { id: "vastu-digital-comm", name: "Digital Commercial Vastu", price: 11000, mode: "Online", location: "Online", description: "Online Vastu analysis for offices and commercial establishments." },
  { id: "vastu-comm-onsite", name: "Commercial Vastu (On-Site)", price: 21000, mode: "In-Person", location: "Guwahati & Bangalore", description: "On-site Vastu consultation for offices and commercial spaces." },
];

export const VASTU_INDUSTRIAL = [
  { id: "vastu-digital-ind", name: "Digital Industrial Vastu", price: 21000, mode: "Online", location: "Online", description: "Online Vastu analysis for industrial and factory properties." },
  { id: "vastu-ind-onsite", name: "Industrial / Factory Vastu (On-Site)", price: 51000, mode: "In-Person", location: "Guwahati & Bangalore", description: "On-site Vastu consultation for factories and large industrial properties." },
];

export const PREMIUM_KUNDLI = {
  id: "premium-kundli",
  name: "Premium Kundli Consultation",
  price: 11000,
  priceSuffix: "",
  mode: "In-Person · Telephone · Online",
  location: "Guwahati & Bangalore / Online",
  description: "Comprehensive kundli analysis with divisional chart study, personalized PDF report, predictions, and practical guidance across all relevant life areas.",
};

export const YEARLY_ASTROLOGY = {
  id: "yearly-astrology",
  name: "Yearly Astrology Consultation",
  price: 25000,
  priceSuffix: " / year",
  mode: "In-Person · Telephone · Online",
  location: "Guwahati & Bangalore / Online",
  description: "3 consultations per year with ongoing transit and dasha analysis, planning support, and precautionary guidance throughout the year.",
};

export const KUNDLI_COMPARISON = [
  { feature: "Birth Chart (Kundli) Analysis", gold: true, premium: true, yearly: true },
  { feature: "Planetary Period (Dasha) Reading", gold: true, premium: true, yearly: true },
  { feature: "Current & Upcoming Transit Analysis", gold: true, premium: true, yearly: true },
  { feature: "Divisional Chart Analysis", gold: false, premium: true, yearly: true },
  { feature: "Personalized PDF Report", gold: false, premium: true, yearly: true },
  { feature: "Life Areas Covered", gold: "Key Areas", premium: "All Major Areas", yearly: "All Major Areas" },
  { feature: "Predictions for Period Ahead", gold: false, premium: true, yearly: true },
  { feature: "Practical & Remedial Guidance", gold: true, premium: true, yearly: true },
  { feature: "Ongoing Transit & Dasha Updates", gold: false, premium: false, yearly: true },
  { feature: "Consultations Included", gold: "1 Session", premium: "1 Session", yearly: "3 per Year" },
  { feature: "Format", gold: "Online / Telephonic", premium: "Phone · Online · In-Person", yearly: "Phone · Online · In-Person" },
];

export const VASTU_OUTSTATION = [
  {
    id: "vastu-india-outside",
    name: "Rest of India",
    price: "₹1,00,000",
    unit: "per day onwards",
    location: "Outside Guwahati & Bengaluru",
    description: "Professional on-site visit fee for Vastu consultations across India, outside Guwahati & Bengaluru.",
    expenses: ["Round-trip flights", "Hotel accommodation", "Local transport", "Other necessary travel expenses"],
  },
  {
    id: "vastu-international",
    name: "International",
    price: "₹5,00,000",
    unit: "per day onwards",
    location: "Worldwide",
    description: "Professional on-site visit fee for Vastu consultations at international locations.",
    expenses: ["Round-trip flights", "Hotel accommodation", "Local transport", "Visas & documentation", "Other necessary travel expenses"],
  },
];

export function buildVastuEnquiryUrl({ location, propertyType, size, requirement, format, dates }) {
  const msg = `Hello Akkshay ji, I would like to enquire about a Vastu consultation.\n\nProject Location: ${location || "—"}\nProperty Type: ${propertyType || "—"}\nSize: ${size || "—"}\nRequirement: ${requirement || "—"}\nPreferred Format: ${format || "—"}\nPreferred Dates: ${dates || "—"}\n\nPlease let me know the next steps.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export const POLICIES = [
  "All consultations are by prior appointment only. No walk-ins.",
  "100% advance payment is mandatory. Booking is confirmed only after full payment.",
  "No rescheduling is permitted within 30 days of the scheduled appointment.",
  "All consultation fees are strictly non-refundable.",
  "Missed or no-show sessions are counted as completed consultations.",
  "For international clients, all session timings are fixed in IST (Indian Standard Time).",
  "No last-minute changes accepted for international consultations.",
];
